function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "yoga");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M972.66888,775.19477C972.66888,799.83981,805.81934,856,600,856s-372.66888-56.16019-372.66888-80.80523S394.18066,766.75244,600,766.75244,972.66888,750.54974,972.66888,775.19477Z",
  transform: "translate(-227.33112 -44)",
  fill: "#3f3d56"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M972.66888,775.19477C972.66888,799.83981,805.81934,856,600,856s-372.66888-56.16019-372.66888-80.80523S394.18066,766.75244,600,766.75244,972.66888,750.54974,972.66888,775.19477Z",
  transform: "translate(-227.33112 -44)",
  opacity: 0.1
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 106.13224,
  cy: 387.47105,
  r: 15.67863,
  fill: "#4527a0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 174.87698,
  cy: 516.5182,
  r: 15.67863,
  fill: "#4527a0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 121.81086,
  cy: 483.9549,
  r: 15.67863,
  fill: "#4527a0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M354.14284,750.4967c-.27677-.45227-6.80286-11.3491-9.06538-33.97664-2.07525-20.75957-.74082-55.75146,17.40643-104.56225,34.37944-92.4688-7.92293-167.07772-8.35518-167.8209l2.087-1.21076c.10953.18845,11.02521,19.2108,17.47356,49.501a215.95631,215.95631,0,0,1-8.94407,120.37161c-34.32055,92.311-8.80509,136.0102-8.54362,136.44127Z",
  transform: "translate(-227.33112 -44)",
  fill: "#cfcce0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M340.69965,439.91339a16.88468,16.88468,0,1,1,16.88467-16.88468A16.90365,16.90365,0,0,1,340.69965,439.91339Zm0-31.35725a14.47258,14.47258,0,1,0,14.47258,14.47257A14.48916,14.48916,0,0,0,340.69965,408.55614Z",
  transform: "translate(-227.33112 -44)",
  fill: "#cfcce0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 162.8165,
  cy: 436.91903,
  r: 15.67863,
  fill: "#cfcce0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M356.37827,536.39724A16.88468,16.88468,0,1,1,373.263,519.51257,16.90364,16.90364,0,0,1,356.37827,536.39724Zm0-31.35725a14.47258,14.47258,0,1,0,14.47258,14.47258A14.48878,14.48878,0,0,0,356.37827,505.04Z",
  transform: "translate(-227.33112 -44)",
  fill: "#cfcce0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M397.38391,568.96054a16.88468,16.88468,0,1,1,16.88468-16.88467A16.90364,16.90364,0,0,1,397.38391,568.96054Zm0-31.35725a14.47258,14.47258,0,1,0,14.47258,14.47258A14.48878,14.48878,0,0,0,397.38391,537.60329Z",
  transform: "translate(-227.33112 -44)",
  fill: "#cfcce0"
});

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 116.98667,
  cy: 558.72989,
  r: 15.67863,
  fill: "#cfcce0"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M363.61456,751.07381s-15.67862-38.59354,31.35725-67.5387Z",
  transform: "translate(-227.33112 -44)",
  fill: "#cfcce0"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M344.33228,750.37374s-7.13548-41.041-62.36294-40.68927Z",
  transform: "translate(-227.33112 -44)",
  fill: "#cfcce0"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M910.36158,765.54639H643.49465s-5.40947-79.33882,26.59653-80.24039,28.39969,35.16152,68.51989-14.42524,88.80538-46.882,95.11642-17.58076-12.17129,52.74228,21.63786,45.52966S937.85969,710.55016,910.36158,765.54639Z",
  transform: "translate(-227.33112 -44)",
  fill: "#4527a0"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M772.42331,765.56444l-.9007-.0361c2.10052-52.236,13.04052-85.79821,21.84806-104.75467,9.563-20.58331,18.77817-28.91585,18.87018-28.99774l.59914.67377c-.09068.081-9.19846,8.33078-18.68484,28.77476C785.39625,680.10079,774.51613,713.52519,772.42331,765.56444Z",
  transform: "translate(-227.33112 -44)",
  fill: "#f2f2f2"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M869.00919,765.67229l-.86548-.25181c10.42185-35.77167,34.96386-58.35688,35.21083-58.581l.60575.66738C903.71552,707.72921,879.35708,730.15463,869.00919,765.67229Z",
  transform: "translate(-227.33112 -44)",
  fill: "#f2f2f2"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M685.5274,765.60846l-.89322-.12414c3.53588-25.50126-2.8511-45.28666-8.832-57.39368-6.4759-13.109-13.86483-20.26877-13.93879-20.33964l.6238-.65065c.07505.07175,7.57822,7.3416,14.12324,20.591C682.64723,719.912,689.09475,739.88005,685.5274,765.60846Z",
  transform: "translate(-227.33112 -44)",
  fill: "#f2f2f2"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M946.58047,766.75244H614.71053l-.07655-1.1242c-.1908-2.79664-4.42434-68.76358,16.95-92.301,4.77826-5.26173,10.53407-8.02363,17.10727-8.20854,13.93257-.39633,22.68819,4.82242,29.75017,9.0112,13.3107,7.89644,22.104,13.11342,54.07548-26.40232,34.635-42.80824,72.00484-52.0179,93.48757-46.8969,13.88016,3.30956,23.44669,12.66291,26.24686,25.66209,2.65119,12.309,1.80672,23.8748,1.12832,33.16809-.72611,9.94342-1.29968,17.79745,2.78427,21.35671,3.40909,2.96977,10.21372,3.24007,21.41325.84977,22.78-4.85953,54.56543-.70137,70.51966,19.91216,8.58367,11.09,15.34531,31.24889-1.18308,64.30627Zm-329.60506-2.4121H945.08705c12.31665-24.9884,12.70119-46.09836,1.1024-61.08445-14.6357-18.90987-45.341-23.88718-68.10933-19.02942-12.16766,2.59642-19.41808,2.16771-23.50086-1.39037-4.99321-4.35072-4.38076-12.73535-3.60578-23.35069.6678-9.13959,1.49814-20.514-1.08-32.485-2.59642-12.05459-11.50751-20.73779-24.44838-23.823-20.79727-4.962-57.123,4.13165-91.0531,46.06715-33.28175,41.13519-43.30761,35.18975-57.1807,26.96-7.14913-4.24-15.2664-9.04889-28.45167-8.675-5.89244.16607-11.07,2.66238-15.39007,7.41944C614.15933,696.10263,616.50488,755.42218,616.97541,764.34034Z",
  transform: "translate(-227.33112 -44)",
  fill: "#cfcce0"
});

var _ref21 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 372.66888,
  cy: 731.19477,
  rx: 372.66888,
  ry: 44.62378,
  fill: "#3f3d56"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M608.19453,191.43773s-18.631-6.65392-30.608,19.96174-30.608,55.89289-30.608,55.89289l10.64626,2.66157s2.66157-18.631,9.31548-21.29253l-2.66157,23.95409s79.847,27.94645,115.77813-2.66156l-1.33079-9.31548s5.32314,1.33078,5.32314,9.31548l3.99234-3.99235s-3.99234-7.9847-15.96939-18.631c-7.86121-6.98775-10.56267-20.28185-11.491-28.59354a34.60155,34.60155,0,0,0-7.96623-18.843C644.65552,190.66965,630.15245,180.8654,608.19453,191.43773Z",
  transform: "translate(-227.33112 -44)",
  fill: "#2f2e41"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M588.54254,295.79064l-19.29677-24.121-14.47258-49.448,55.47822-59.09636s12.06048-45.82983,1.20605-43.41773-13.26653,36.18144-13.26653,36.18144l-69.95079,54.27217s7.23628,75.981,27.7391,102.51409l15.67863,49.448Z",
  transform: "translate(-227.33112 -44)",
  fill: "#ffb9b9"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M641.60866,295.79064l19.29677-24.121,14.47258-49.448-55.47822-59.09636s-12.06048-45.82983-1.206-43.41773,13.26653,36.18144,13.26653,36.18144l69.95079,54.27217s-7.23629,75.981-27.73911,102.51409l-15.67862,49.448Z",
  transform: "translate(-227.33112 -44)",
  fill: "#ffb9b9"
});

var _ref25 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 387.74448,
  cy: 199.93056,
  r: 31.35725,
  fill: "#ffb9b9"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M600.603,260.81524s1.20605,25.327-6.03024,33.76935-14.47257,51.86007,20.50282,53.06612,31.35725-36.18145,31.35725-36.18145l-7.23629-20.50282s-10.85443-15.67862-7.23628-30.1512Z",
  transform: "translate(-227.33112 -44)",
  fill: "#ffb9b9"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M568.03972,541.82446l25.93,7.83931s21.10584-12.66351,21.10584-.603-7.23629,27.7391-4.82419,38.59354,7.23629,37.38749,0,37.38749-21.70887-47.03588-21.70887-47.03588l-24.121-13.26653Z",
  transform: "translate(-227.33112 -44)",
  fill: "#ffb9b9"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M600.603,710.6712l-9.64838,37.38749s-8.44234,10.85443,0,15.67863c3.96151,2.26372,6.86079,6.91748,8.82244,11.21981a20.62755,20.62755,0,0,0,20.25468,12.25369c4.11647-.34166,7.58409-1.96885,8.42756-6.19842a9.70517,9.70517,0,0,0-1.8675-7.60029c-8.89649-12.02189-10.91319-19.9262-10.91319-19.9262l3.61814-42.21169Z",
  transform: "translate(-227.33112 -44)",
  fill: "#ffb9b9"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M577.24951,249.49962s10.64626-14.63861,19.96174-17.30018S607.85752,216.23,607.85752,216.23s23.95409,26.61566,38.59271,27.94645,1.33078-31.9388,1.33078-31.9388l-26.61566-6.65391-25.28488,2.66157-19.96174,13.30783Z",
  transform: "translate(-227.33112 -44)",
  fill: "#2f2e41"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M557.18529,450.1648l-4.82419,9.64838s-116.98667,37.3875-107.33829,72.36289,63.92055,25.327,63.92055,25.327l60.30241,10.85444,6.03024-26.53306L533.06433,530.97,605.42722,504.437l2.41209,123.01692-9.64838,88.04151,24.121,2.4121s26.53306-80.80523,22.91492-114.57458c0,0,44.62378-137.48949,19.29677-157.9923S557.18529,450.1648,557.18529,450.1648Z",
  transform: "translate(-227.33112 -44)",
  fill: "#2f2e41"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M616.48977,311.4859l-18.81885-22.74346-12.74652,5.84215-13.26653,42.21168S560.80344,357.29909,574.07,379.008c0,0,2.4121,14.47258-1.206,18.09072s-4.8242,26.53306-4.8242,26.53306l-15.67862,30.1512s89.24756,15.67863,115.78062-6.03024c0,0-13.92292-51.33112-5.48058-67.00975s9.64838-39.7142,0-50.56864-19.84643-39.20787-19.84643-39.20787l-5.84078-3.7355Z",
  transform: "translate(-227.33112 -44)",
  fill: "#cfcce0"
});

var _ref32 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "459.515 87.42 447.948 87.42 447.948 75.853 446.897 75.853 446.897 87.42 435.33 87.42 435.33 88.471 446.897 88.471 446.897 100.038 447.948 100.038 447.948 88.471 459.515 88.471 459.515 87.42",
  fill: "#cfcce0"
});

var _ref33 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "349.583 63.235 338.016 63.235 338.016 51.668 336.965 51.668 336.965 63.235 325.398 63.235 325.398 64.286 336.965 64.286 336.965 75.853 338.016 75.853 338.016 64.286 349.583 64.286 349.583 63.235",
  fill: "#cfcce0"
});

var _ref34 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "402.35 11.567 390.784 11.567 390.784 0 389.732 0 389.732 11.567 378.165 11.567 378.165 12.618 389.732 12.618 389.732 24.185 390.784 24.185 390.784 12.618 402.35 12.618 402.35 11.567",
  fill: "#cfcce0"
});

var SvgUndrawYoga248N = function SvgUndrawYoga248N(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "e1212692-d39e-496f-931d-018692dccc58",
    "data-name": "Layer 1",
    width: 745.33776,
    height: 812,
    viewBox: "0 0 745.33776 812",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawYoga248N, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_yoga_248n.8597ea08.svg";
export { ForwardRef as ReactComponent };